import { render } from "./AddGroupView.vue?vue&type=template&id=2def82ce&scoped=true&ts=true"
import script from "./AddGroupView.vue?vue&type=script&lang=ts"
export * from "./AddGroupView.vue?vue&type=script&lang=ts"

import "./AddGroupView.vue?vue&type=style&index=0&id=2def82ce&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2def82ce"]])

export default __exports__